export default "__VITE_ASSET__CoM3NUvQ__"